<template>
  <div class="address">
    <div class="address__content">
      <div class="address__header">
        <BaseHeading :size="3">{{heading}}</BaseHeading>
      </div>
      <BaseText>
        <p>
          <template v-if="!isPublished">
            Mer information kommer inom kort
          </template>
          <template v-else>
            {{address1}}<br>{{address2}}<br>
            <a :href="link" target="_blank">Hitta hit</a>
          </template>
        </p>
      </BaseText>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectionAddress',
  props: {
    heading: String,
    address1: String,
    address2: String,
    openingHours: String,
    link: String,
    isPublished: Boolean
  }
}
</script>
<style lang="scss" scoped>
  @import './section-address'
</style>



// WEBPACK FOOTER //
// src/views/ViewOrder/components/SectionAddress/SectionAddress.vue